export default __webpack_public_path__ + "static/media/NextMaintenanceIcon.5e4042a1.svg";